import ServerError from "../Screens/ErrorHandling/ServerError";
import NoInternet from "../Screens/ErrorHandling/NoInternet";
import { ErrorBoundary } from "react-error-boundary";
import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";

class NoInternetError extends Error {}
class NetworkError extends Error {}
class ServerErr extends Error {}

function ErrorFallback({ error }) {
  if (error instanceof NoInternetError) {
    return <NoInternet />;
  } else if (error instanceof NetworkError) {
    return <NetworkError />;
  } else if (error instanceof ServerErr) {
    return <ServerError />;
  } else {
    return null;
  }
}

const MyErrorBoundary = ({ children }) => {
  const [isOnline, setIsOnline] = useState(
    typeof navigator !== "undefined" && navigator.onLine
  );

  useEffect(() => {
    const handleOnline = () => {
      setIsOnline(true);
    };
    const handleOffline = () => {
      setIsOnline(false);
    };
    window.addEventListener("online", handleOnline);
    window.addEventListener("offline", handleOffline);
    return () => {
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("offline", handleOffline);
    };
  }, []);

  const handleRetry = () => {
    window.location.reload();
  };

  let content = children;
  if (!isOnline) {
    //no internet
    content = <NoInternet />;
  }

  return (
    <ErrorBoundary
      FallbackComponent={ErrorFallback}
      onReset={handleRetry}
      resetKeys={[children]}
    >
      {content}
    </ErrorBoundary>
  );
};

MyErrorBoundary.propTypes = {
  children: PropTypes.any,
};

ErrorFallback.propTypes = {
  error: PropTypes.any,
};

export default MyErrorBoundary;
